import React from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TitlePage from 'components/TituloPage';
import { postosAtendimentoListar } from 'routes/paths';
import { fetchGetTodasSolicitacao } from 'store/fetchActions/fetchInputForm';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { ALERTA, MSG_SALVAR_SERVICO_SUCESSO } from 'utils/consts';
import FormularioPostosAtendimento from 'containers/Forms/FormPostosAtendimento/index';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { validationsCreateUpdate } from 'utils/validate/postosAtendimento';
import { validarExibirErrosCampos } from 'utils/formUtils';
import * as S from '../styles';
import * as Style from 'components/Style';
import { fetchSalvarNovoPostoAtendimento } from 'store/fetchActions/fetchPostosAtendimento';
import {
  formatterPostosAtendimentoFrontToBackCreate,
  formatterPostosAtendimentoNull,
} from 'utils/formatter/postosAtendimento';

export default function PostosAtendimento() {
  const dispatch = useDispatch();
  const history = useHistory();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const inputSelectOptionsServicos = useSelector(state => state.inputs.inputSelectOptionsServicos);

  const {
    control,
    setValue,
    setError,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: formatterPostosAtendimentoNull(),
  });

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodasSolicitacao());
  }, [dispatch, unitaryTests]);

  const validarCampos = data => {
    return validarExibirErrosCampos(data, validationsCreateUpdate, setError);
  };

  const onSubmit = () => {
    const data = getValues();
    if (validarCampos(data)) {
      dispatch(fetchSalvarNovoPostoAtendimento(formatterPostosAtendimentoFrontToBackCreate(data))).then(() => {
        history.push(postosAtendimentoListar);
        fetchNotificationApp(MSG_SALVAR_SERVICO_SUCESSO, '', ALERTA.SUCESSO);
      });
    }
  };

  return (
    <S.Page>
      <TitlePage textTitle={'CADASTRO DE POSTOS DE ATENDIMENTO'} backPage={postosAtendimentoListar} />
      <Style.GlobalCard>
        <FormularioPostosAtendimento
          errors={errors}
          control={control}
          getValues={getValues}
          setValue={setValue}
          setError={setError}
          optionsServicos={montarDadosInputSelect(inputSelectOptionsServicos, 'id', 'nome')}
          onSubmit={onSubmit}
          disabled={false}
        />
      </Style.GlobalCard>
    </S.Page>
  );
}
